import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CcLoader } from '@utp/components-react';
import OutsideClickHandler from 'react-outside-click-handler';
import Block from '../../../../components/Block';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import { SelectElement, SelectWrapper, LabelSelect } from './styles';
import { ISelect } from './Interfaces';
import ButtonInteractiveSelect from './components';
import Toggle from '../Buttons/Toggle';

function Select(props: ISelect) {
  const {
    options,
    handleChangeSelect,
    isRequired,
    placeholder,
    disabled,
    value,
    isLoading
  } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [currentValue, setCurrentValue]: any = useState<any>(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isContainerFocused, setIsContainerFocused] = useState(false);
  const [highlightedIndex, setHighlightedIndex] = useState(-1); // -1 = nothing selected
  const menuContainerRef: any = useRef(null);
  const menuButtonRef: any = useRef(null);
  const toggleRef: any = useRef(null);

  const KEY_CODES = Object.freeze({
    RETURN: 13,
    ESC: 27,
    SPACE: 32,
    END: 35,
    HOME: 36,
    UP: 38,
    DOWN: 40,
    TAB: 9,
    ENTER: 16
  });

  const itemsCount = options.length - 1;
  const focusMenu = () => {
    if (menuButtonRef && menuButtonRef.current) {
      menuButtonRef?.current.focus();
    }
  };
  const focusFirstItem = () => setHighlightedIndex(0);
  const focusLastItem = () => setHighlightedIndex(itemsCount);
  const focusNextItem = () => {
    if (highlightedIndex === itemsCount) {
      focusFirstItem();
    } else {
      setHighlightedIndex(highlightedIndex + 1);
    }
  };

  const focusPrevItem = () => {
    if (highlightedIndex === 0) {
      focusLastItem();
    } else {
      setHighlightedIndex(highlightedIndex - 1);
    }
  };
  const closeMenu = useCallback(() => {
    setIsOpen(false);
    setHighlightedIndex(-1);
    focusMenu();
  }, []);

  const openMenu = () => {
    setIsOpen(true);
    setIsFocused(true);
    focusMenu();
  };

  const buttonHandleClick = () => {
    if (toggleRef && toggleRef.current) {
      toggleRef.current.childNodes[0].childNodes[0].click();
    }
    // setOpenmenu(!openmenu);
    if (isOpen) {
      closeMenu();
    } else {
      openMenu();
    }
  };
  const buttonHandleKeyEvents = (event: any) => {
    event.preventDefault();
    switch (event.keyCode) {
      case KEY_CODES.SPACE:
      case KEY_CODES.RETURN:
      case KEY_CODES.DOWN:
        // setOpenmenu(false);
        closeMenu();
        break;
      case KEY_CODES.UP:
      case KEY_CODES.TAB:
      case KEY_CODES.ENTER:
        openMenu();
        break;
      default:
        // setOpenmenu(false);
        closeMenu();
        break;
    }
  };

  const menuHandleKeyEvents = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    switch (event.keyCode) {
      case KEY_CODES.TAB:
      case KEY_CODES.SPACE:
      case KEY_CODES.DOWN:
        focusNextItem();
        break;
      case KEY_CODES.UP:
        focusPrevItem();
        break;
      case KEY_CODES.ESC:
        // setOpenmenu(false);
        closeMenu();
        break;
      case KEY_CODES.ENTER:
        openMenu();
        // setOpenmenu(false);
        // selectFocusItem(event);
        break;
      default:
        break;
    }
  };

  const menuItemsHandleKeyEvents = (event: any) => {
    if (
      event.keyCode === KEY_CODES.SPACE ||
      event.keyCode === KEY_CODES.RETURN
    ) {
      event.stopPropagation();
      // return;
    }
  };

  const updateLabel = (item: any) => {
    // handleUpdateDropdown(getWeeek(ind + 1, data));

    if (item?.value !== currentValue?.value) {
      setCurrentValue(item);
      handleChangeSelect(item);
    }
    closeMenu();

    // if (toggleRef && toggleRef.current) {
    //   toggleRef.current.childNodes[0].childNodes[0].click();
    // }
    // setOpenmenu(false);
    // getValue(item);
  };

  useEffect(() => {
    if (isOpen && menuContainerRef && menuContainerRef.current) {
      const nodes = menuContainerRef?.current.childNodes || 0;

      if (highlightedIndex >= 0 && highlightedIndex < nodes.length) {
        nodes[highlightedIndex].focus();
      }
    } else if (menuButtonRef && menuButtonRef.current) {
      // if the menu is closed, focus the button.
      menuButtonRef?.current.focus();
    }
  }, [isOpen, highlightedIndex]);

  useEffect(() => {
    if (!isFocused && !isContainerFocused) {
      closeMenu();
      // setOpenmenu(false);
    }
  }, [isFocused, isContainerFocused]);

  useEffect(() => {
    if (!value) {
      updateLabel('');
    }
  }, [value]);

  return (
    <SelectElement data-testid="cmp-select-element">
      <OutsideClickHandler
        onOutsideClick={() => {
          // setOpenmenu(false);
          closeMenu();
          if (currentValue !== null && isRequired) {
            // onValidate();
          } else {
            // onError();
          }
        }}
      >
        <SelectWrapper
          tabIndex={0}
          isEmpty={!currentValue?.label}
          disabled={disabled}
        >
          <Block
            data-testid="btn-dropdown-container"
            customized
            id="menubutton"
            className="selected"
            role="button"
            aria-haspopup="true"
            aria-controls="menu2"
            onClick={buttonHandleClick}
            onKeyDown={buttonHandleKeyEvents}
            onFocus={() => setIsContainerFocused(true)}
            onBlur={() => setIsContainerFocused(false)}
            aria-expanded={isOpen}
            flexDirection="row"
          >
            <Block customized padding="10px 8px 10px 16px">
              <LabelSelect color={disabled ? '#8090BB' : 'var(--text-text02)'}>
                {!currentValue?.label ? placeholder : currentValue?.label}
              </LabelSelect>
            </Block>
            {/* {isOpen ? (
              <CcIcon name="chevron-up" />
            ) : (
              <CcIcon name="chevron-down" />
            )} */}
            <div className="button-toggle" ref={toggleRef}>
              {isLoading ? (
                <div
                  style={{
                    color: '#5B36F2',
                    marginTop: '3px',
                    marginRight: '3px'
                  }}
                >
                  <CcLoader size={16} />
                </div>
              ) : (
                <Toggle
                  disabled={disabled}
                  onClick={() => {}}
                  sizeButton="24px"
                  sizeIcon="24px"
                  animationExternal
                  animationEffect={isOpen}
                  itStartsOpened={false}
                />
              )}
            </div>
          </Block>
          <div
            id="menu2"
            data-testid="dropdown-menu2"
            aria-labelledby="menubutton"
            ref={menuContainerRef}
            role="menu"
            onFocus={() => {}}
            onKeyDown={menuHandleKeyEvents}
            className={`menu ${isOpen ? 'active' : ''}`}
            tabIndex={0}
          >
            {options && options.length ? (
              <Block className="menu-container">
                {options.map((item: any) => (
                  <ButtonInteractiveSelect
                    type="button"
                    width="100%"
                    key={IDHelpers.generateID()}
                    onClick={() => {
                      updateLabel(item);
                    }}
                    onKeyDown={menuItemsHandleKeyEvents}
                    bkgColorEnabled="#ffffff"
                    bkgColorHover="#D5E5F0"
                    bkgColorFocus="#A8CBE2"
                    bkgColorPressed="#A8CBE2"
                    padding="10px 16px"
                    item={item}
                    currentValue={currentValue}
                    onBlur={() => setIsFocused(false)}
                    onFocus={() => setIsFocused(true)}
                  >
                    {item.label}
                  </ButtonInteractiveSelect>
                ))}
              </Block>
            ) : (
              <></>
            )}
          </div>
        </SelectWrapper>
      </OutsideClickHandler>
    </SelectElement>
  );
}
Select.defaultProps = {
  options: [],
  placeholder: '',
  value: '',
  handleChangeSelect: () => {},
  getValue: () => {},
  onValidate: () => {},
  onError: () => {},
  isRequired: false,
  disabled: false,
  isLoading: false
};
export default Select;
